import SolutionPartnerService from '@/services/SolutionPartnerService';
import SupplierService from '@/services/SupplierService';

export default {
  getToken ({ url }) {
    return SolutionPartnerService.singleSignOnV2({
      redirectPath: url,
    });
  },
  redirectUrlGenerator ({ token }) {
    return token.redirectFullPath || '/';
  },
  getGtmEvent () {
    return {
      event: 'GAEvent',
      eventCategory: 'AccountSSOPage',
      action: 'Solution Partner SSO',
      eventLabel: SupplierService.getSupplierId(),
    };
  },
};
